import { TagIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { getIconByName } from '../../../utils/iconMapping';

export default function CategoryTag({
  category,
  isSelected = false,
  onClick,
  count = null,
  size = 'default', // 'small', 'default', 'large'
  showIcon = true,
  className = ''
}) {
  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    default: 'px-3 py-1.5 text-sm',
    large: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    small: 'w-3 h-3',
    default: 'w-4 h-4',
    large: 'w-5 h-5'
  };

  // Use custom color if provided, otherwise use default theme colors
  const hasCustomColor = category.color && category.color !== '#3B82F6';

  const buttonStyle = hasCustomColor && !isSelected ? {
    backgroundColor: `${category.color}20`,
    borderColor: `${category.color}40`,
    borderWidth: '1px',
    color: category.color
  } : {};

  const selectedStyle = hasCustomColor && isSelected ? {
    backgroundColor: `${category.color}30`,
    borderColor: category.color,
    borderWidth: '1px',
    color: category.color,
    fontWeight: '600'
  } : {};

  return (
    <motion.button
      onClick={onClick}
      className={`
        inline-flex items-center gap-1.5 rounded-lg font-medium
        transition-all duration-200
        ${isSelected
          ? hasCustomColor ? 'border' : 'bg-primary text-primary-content border border-primary shadow-sm'
          : hasCustomColor ? 'border' : 'bg-base-100 text-base-content border border-base-300 hover:bg-base-200 hover:border-base-content/20'
        }
        ${sizeClasses[size]}
        ${className}
      `}
      style={isSelected ? selectedStyle : buttonStyle}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {showIcon && (
        category.icon
          ? getIconByName(category.icon, `${iconSizes[size]} opacity-70`)
          : <TagIcon className={`${iconSizes[size]} opacity-70`} />
      )}
      <span>{category.name}</span>
      {count !== null && (
        <span
          className={`ml-1 px-1.5 py-0.5 rounded text-xs font-medium ${
            !hasCustomColor ? 'bg-base-content/10' : ''
          }`}
          style={hasCustomColor ? {
            backgroundColor: `${category.color}20`,
            color: category.color
          } : {}}
        >
          {count}
        </span>
      )}
    </motion.button>
  );
}